import { baseApi } from 'src/Services/api.ts'
import { PaginatedResponse } from 'src/Redux/types.ts'

export interface ModelType {
  id: number

  label: string
  createdAt: string
  updatedAt: string
  models?: {
    id: number
    name: string
  }[]
}

export interface CreateModelTypeBody {
  label: string
}

export interface ModelTypeQueryParams {
  page?: number
  limit?: number
  label?: string
  all?: boolean
}

export const modelTypesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllModelTypes: builder.query<
      PaginatedResponse<ModelType[]>,
      ModelTypeQueryParams | void
    >({
      query: (params) => {
        const queryParams = new URLSearchParams()

        if (params) {
          if (params.page) queryParams.append('page', params.page.toString())
          if (params.limit) queryParams.append('limit', params.limit.toString())
          if (params.label) queryParams.append('label', params.label)
          if (params.all) queryParams.append('all', 'true')
        }

        const queryString = queryParams.toString()
        return `/model-types${queryString ? `?${queryString}` : ''}`
      },
      providesTags: ['modelTypes'],
    }),

    addModelType: builder.mutation<ModelType, CreateModelTypeBody>({
      query: (data) => ({
        url: `/model-types`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['modelTypes'],
    }),

    deleteModelType: builder.mutation<{ message: string }, number>({
      query: (id) => ({
        url: `/model-types/${id}`,
        method: 'DELETE',
        body: {},
      }),
      invalidatesTags: ['modelTypes'],
    }),
  }),
  overrideExisting: true,
})

export const {
  useGetAllModelTypesQuery,
  useAddModelTypeMutation,
  useDeleteModelTypeMutation,
} = modelTypesApi
